import React from 'react'


export default class extends React.Component {

  render() {
    document.title = "LinkedIn Peter van der Meer - Ik maak LinkedIn gemakkelijk. - Ghostin.nl";

    var headTag = document.getElementsByTagName('head')[0];
    var charsetTag = document.createElement('meta');
    charsetTag.setAttribute("http-equiv", "refresh");
    charsetTag.setAttribute("content", "0; URL='https://www.linkedin.com/in/peterdotplus/'");
    headTag.appendChild(charsetTag);

    return (
      <div style={{margin:"3em"}}>Je wordt doorgestuurd naar <a href="https://www.linkedin.com/in/peterdotplus/">linkedin.com/in/peterdotplus/</a></div>
      );
  }

}



// WEBPACK FOOTER //
// ./src/containers/redir_li.js